import type { GalleryState } from "../types";

/**
 * Starter content. These details (titles, media, sizes, prices) are placeholders
 * TL can edit from the Admin page. The images live in src/assets/art and are
 * referenced by `seedKey`.
 */
export const SEED: GalleryState = {
  collections: [
    {
      id: "coastal",
      name: "Coastal",
      description:
        "Salt air, low tide, and long light. Paintings drawn from the shoreline and the birds that work it.",
      coverArtId: "heron",
      createdAt: 1,
    },
    {
      id: "botanicals",
      name: "Botanicals",
      description: "Flowers and still life, painted close and unhurried.",
      coverArtId: "flowers-vase",
      createdAt: 2,
    },
    {
      id: "small-works",
      name: "Small Works & Ornaments",
      description:
        "Hand-painted wood rounds and miniature canvases. One of a kind, made for gifting.",
      coverArtId: "gnome",
      createdAt: 3,
    },
  ],
  artworks: [
    {
      id: "heron",
      seedKey: "heron",
      title: "Sentinel",
      year: "2024",
      medium: "Acrylic on canvas",
      dimensions: "16 × 20 in",
      description:
        "A great egret holding a piling at the turn of the tide. Built up in thin, scraped layers so the water keeps moving behind it.",
      collectionId: "coastal",
      status: "available",
      price: "$480",
      featured: true,
      createdAt: 101,
    },
    {
      id: "palm-beach",
      seedKey: "palm-beach",
      title: "Trade Winds",
      year: "2024",
      medium: "Oil on canvas",
      dimensions: "11 × 14 in",
      description:
        "Palms leaning into the wind above a turquoise break. Painted with a knife to keep the fronds loose and quick.",
      collectionId: "coastal",
      status: "available",
      price: "$420",
      featured: true,
      createdAt: 102,
    },
    {
      id: "river-sunset",
      seedKey: "river-sunset",
      title: "Marsh at Dusk",
      year: "2024",
      medium: "Acrylic on paper, framed",
      dimensions: "9 × 12 in",
      description:
        "A tidal creek winding back to a pink sky. The mat and frame are hand-finished to match the water.",
      collectionId: "coastal",
      status: "available",
      price: "$360",
      featured: true,
      createdAt: 103,
    },
    {
      id: "flamingos",
      title: "Flamingos",
      medium: "Acrylic on canvas",
      dimensions: "20 × 16 in",
      galleryAttribution: "Through PAStA Fine Art Gallery",
      description:
        "Palette knife acrylic in a vivid coastal palette. Original piece currently offered through PAStA Fine Art Gallery.",
      collectionId: "coastal",
      status: "available",
      price: "$350",
      featured: true,
      createdAt: 104,
    },
    {
      id: "flowers-vase",
      seedKey: "flowers-vase",
      title: "Geraniums in Blue",
      year: "2024",
      medium: "Watercolor & ink",
      dimensions: "8 × 8 in",
      description:
        "Potted geraniums against a washed sky, drawn in ink first and flooded with color.",
      collectionId: "botanicals",
      status: "available",
      price: "$220",
      featured: true,
      createdAt: 105,
    },
    {
      id: "penguins",
      seedKey: "penguins",
      title: "Three Penguins",
      year: "2023",
      medium: "Acrylic on mini canvas",
      dimensions: "4 × 4 in",
      description: "A trio in Santa hats. Signed on the front.",
      collectionId: "small-works",
      status: "sold",
      createdAt: 106,
    },
    {
      id: "gnome",
      seedKey: "gnome",
      title: "Holiday Gnome",
      year: "2023",
      medium: "Acrylic on wood round",
      dimensions: "4 in round",
      description: "Painted on a bark-edged wood slice, strung for hanging.",
      collectionId: "small-works",
      status: "available",
      price: "$28",
      createdAt: 107,
    },
    {
      id: "hedgehog",
      seedKey: "hedgehog",
      title: "Winter Hedgehog",
      year: "2023",
      medium: "Ink & acrylic on wood round",
      dimensions: "3.5 in round",
      collectionId: "small-works",
      status: "available",
      price: "$28",
      createdAt: 108,
    },
    {
      id: "pineapple",
      seedKey: "pineapple",
      title: "Pineapple",
      year: "2023",
      medium: "Acrylic on wood round",
      dimensions: "3.5 in round",
      collectionId: "small-works",
      status: "available",
      price: "$28",
      createdAt: 109,
    },
  ],
};
